export const sortActions = (a, b) => {
  if (a.meeting === 'session' && b.meeting === 'session')
    return a.procedure - b.procedure;
  if (a.meeting === 'session') return 1;
  if (b.meeting === 'session') return -1;
  return Number(a.meeting) - Number(b.meeting);
};
